import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Textarea“ of the review modal (154:4564): 112 px box, radius 12, 1 px #E2E5DF border, 16 / 12
 * padding, Body/L value, #8F978E placeholder. Focus = green border + the `shadow-focus` ring like the
 * `TextInput` of the form kit; an invalid box stays red. Forwards the ref for `register()`.
 */
export const ReviewTextarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }
>(function ReviewTextarea({ invalid, className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'nt-body-l block h-28 w-full resize-none rounded-xl border bg-white px-4 py-3 text-[#0D110D] outline-none transition-colors placeholder:text-[#8F978E] focus:shadow-focus',
        invalid ? 'border-[#D92D20]' : 'border-[#E2E5DF] focus:border-[#127A26]',
        className,
      )}
      {...props}
    />
  );
});
